import React, {FC} from 'react';
import {StatusBadge} from "@scope/scope-one-ui/core"; 
import makeStyles from '@mui/styles/makeStyles';

import {BaseProps} from 'shared/types/base';
import {SubscriberConfirmation, SubscriberConfirmations} from '../types';

const useStyles = makeStyles(theme => ({
  icon: {
    position: 'relative',
    marginRight: theme.spacing(0.5),
    fontSize: 'inherit',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
}));

type SubscriberConfirmationIndicatorProps = {
  status: SubscriberConfirmation;
} & BaseProps;

const SubscriberConfirmationIndicator: FC<SubscriberConfirmationIndicatorProps> = ({status}) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      {status === SubscriberConfirmations.SIGNED && <StatusBadge status='SIGNED'/>}
      {status === SubscriberConfirmations.SENT && <StatusBadge status='SENT'/>}
    </div>
  );
};

export default SubscriberConfirmationIndicator;
